import { Zap, Shield, BarChart3, Flame } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "../components/ui/tooltip";
import { formatUSD } from "../data/api";
import { PriceDisplay } from "./PriceDisplay";

const statItems = [
  { key: "price_usd", label: "Price", icon: Zap, color: "text-fire-orange", bg: "bg-fire-orange/10", borderColor: "border-fire-ember/30", tooltip: "Current price (DexScreener)", isPrice: true },
  { key: "market_cap", label: "Market Cap", icon: Shield, color: "text-fire-red", bg: "bg-fire-red/10", borderColor: "border-fire-dark/50", tooltip: "Fully diluted valuation", format: (v) => formatUSD(v) },
  { key: "volume_24h", label: "24h Volume", icon: BarChart3, color: "text-fire-ember", bg: "bg-fire-ember/10", borderColor: "border-fire-dark/30", tooltip: "24h trading volume", format: (v) => formatUSD(v) },
  { key: "liquidity_usd", label: "Liquidity", icon: Flame, color: "text-fire-red", bg: "bg-fire-red/10", borderColor: "border-fire-dark/50", tooltip: "Pool liquidity", format: (v) => formatUSD(v) },
];

export const StatsBar = ({ stats }) => {
  const priceChange = stats?.price_change_24h || 0;

  return (
    <TooltipProvider delayDuration={200}>
      <section data-testid="stats-bar" className="w-full px-4 sm:px-6 md:px-12 lg:px-20 -mt-8 sm:-mt-12 relative z-30">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {statItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <Tooltip key={item.key}>
                <TooltipTrigger asChild>
                  <div data-testid={`stat-card-${item.key}`} className="card-forge p-3 sm:p-5 flex items-center gap-3 sm:gap-4 animate-slide-in-up" style={{ animationDelay: `${index * 0.1}s`, borderRadius: "2px" }}>
                    <div className={`${item.bg} ${item.borderColor} border p-2.5 flex items-center justify-center`} style={{ borderRadius: "2px" }}>
                      <Icon className={`w-5 h-5 ${item.color}`} />
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="font-mono text-[10px] text-muted-foreground/60 uppercase tracking-[0.15em] sm:tracking-[0.2em] mb-1">{item.label}</p>
                      {item.isPrice ? (
                        <>
                          <PriceDisplay price={stats?.[item.key]} className="font-mono text-sm sm:text-lg font-bold text-foreground stat-value" />
                          {priceChange !== 0 && (
                            <p className={`font-mono text-[10px] mt-0.5 ${priceChange > 0 ? "text-green-500" : "text-red-400"}`}>
                              {priceChange > 0 ? "+" : ""}{priceChange.toFixed(2)}% (24h)
                            </p>
                          )}
                        </>
                      ) : (
                        <p className="font-mono text-sm sm:text-lg font-bold text-foreground stat-value truncate">{item.format(stats?.[item.key])}</p>
                      )}
                    </div>
                  </div>
                </TooltipTrigger>
                <TooltipContent className="bg-forge-surface border-forge-steel text-foreground font-mono text-xs" style={{ borderRadius: "2px" }}>{item.tooltip}</TooltipContent>
              </Tooltip>
            );
          })}
        </div>
      </section>
    </TooltipProvider>
  );
};
